import {  createSlice } from "@reduxjs/toolkit";
import {  stateEnum } from "../constants/enum"
const { monthExpEntry } = stateEnum

const initialState = {
    detailParams: {},
    isNewEntry: false,
}


const monthExpEntrySlice = createSlice({
    name: monthExpEntry,
    initialState,
    reducers: {
        resetDetailParams: (state) => {
            state.detailParams = {}
            state.isNewEntry = true
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
        },
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload
        },

    },
})

export const { resetDetailParams, setNewEntryMode, setDetailParams } = monthExpEntrySlice.actions

export default monthExpEntrySlice.reducer

